import { getFormattedPageNumber, timeToStandard } from '@frameio/utils/media';
import type { QuickSearchAssetV2Fragment as QuickSearchAssetFragment } from '../gql/generated/QuickSearchAssetV2';

/**
 * Returns the duration info for an asset, including the original value and formatted value.
 *
 * The original value is the duration in seconds for video and audio assets, and the page count for document assets.
 *
 * The formatted value is the duration in a human-readable format for video and audio assets, and the page count for document assets.
 */
export const getAssetDurationInfo = (
  thumbnailInfo: QuickSearchAssetFragment
): { originalValue: number; formattedValue: string } | undefined => {
  if (thumbnailInfo?.__typename === 'DocumentAsset') {
    const pageCount = thumbnailInfo.media?.pageCount ?? 0;

    return {
      originalValue: pageCount,
      formattedValue: getFormattedPageNumber(pageCount),
    };
  }

  if (
    thumbnailInfo?.__typename === 'VideoAsset' ||
    thumbnailInfo?.__typename === 'AudioAsset'
  ) {
    const duration = thumbnailInfo.media?.duration ?? 0;

    return {
      originalValue: duration,
      formattedValue: timeToStandard(duration),
    };
  }

  return undefined;
};
